import { BASE_API_URL, handleAPIResponse } from './Base';

export async function getRiver(riverKey) {
  const response = await fetch(`${BASE_API_URL}/rivers/${riverKey}`)
  return await handleAPIResponse(response)
}

export async function getRiverData(riverKey) {
  const response = await fetch(`${BASE_API_URL}/rivers/${riverKey}/data`)
  return await handleAPIResponse(response)
}

